import { useNavigate } from 'react-router-dom'
import { useChatContext } from '../context/ChatContext.jsx'

export default function NavPrompt({ message }) {
  const navigate = useNavigate()
  const { markNavDecided, setNavAlwaysAllow } = useChatContext()

  const path = message.returned_slug
    ? `${message.returned_path}/${message.returned_slug}`
    : message.returned_path

  const handleAllowOnce = () => {
    navigate(path)
    markNavDecided(message.id)
  }
  const handleAlwaysAllow = () => {
    navigate(path)
    markNavDecided(message.id)
    setNavAlwaysAllow(true)
  }
  const handleDeny = () => {
    markNavDecided(message.id)
  }

  return (
    <div className="mt-2 ml-1">
      <p className="text-xs text-soft-dim mb-1.5">Navigate to {path}?</p>
      <div className="flex gap-2">
        <button
          onClick={handleAllowOnce}
          className="px-2.5 py-1 text-xs border border-soft-rule bg-soft-hi text-soft-ink hover:bg-soft-rule cursor-pointer"
        >
          Allow once
        </button>
        <button
          onClick={handleAlwaysAllow}
          className="px-2.5 py-1 text-xs bg-soft-ink text-soft-bg hover:bg-soft-dim cursor-pointer"
        >
          Always allow
        </button>
        <button
          onClick={handleDeny}
          className="px-2.5 py-1 text-xs border border-soft-rule text-soft-dim hover:text-soft-ink cursor-pointer"
        >
          Deny
        </button>
      </div>
    </div>
  )
}
